<template>
  <div>
    <el-dialog
      title="批量退回"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="close"
      :close-on-click-modal="false"
    >
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <el-tab-pane label="批量退回" name="return">
          <el-form
            ref="returnForm"
            :model="returnForm"
            :rules="returnRules"
            label-position="top"
          >
          <div class="form-label"><span class="required-asterisk">*</span>调整影响</div>
          <el-table :data="impactData" border stripe style="width: 100%;" class="impact-table">
                <el-table-column
                  prop="returnCustomer"
                  label="退回客户"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="coverProvince"
                  label="覆盖省份"
                  align="center"
                ></el-table-column>
              </el-table>
            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="returnForm.remark"
                type="textarea"
                :rows="4"
                placeholder="请输入备注"
                maxlength="1000"
                show-word-limit
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="历史记录" name="history">
          <el-table :data="historyData" :max-height="400" stripe border>
            <el-table-column
              type="index"
              width="50"
              align="center"
              label="序号"
            ></el-table-column>
            <el-table-column
              prop="operationTime"
              label="操作时间"
              align="center"
              min-width="200"
            ></el-table-column>
            <el-table-column
              prop="operator"
              label="操作人员"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="adjustImpact"
              label="调整影响"
              align="center"
              min-width="200"
            ></el-table-column>
            <el-table-column
              prop="effectiveTime"
              label="生效时间"
              align="center"
              min-width="200"
            ></el-table-column>
            <el-table-column
              prop="executionStatus"
              label="执行状态"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
              align="center"
              min-width="150"
            ></el-table-column>
          </el-table>
          <div class="block" v-if="historyTotal > 0">
            <el-pagination
              @current-change="handleHistoryPageChange"
              :current-page.sync="historyCurrentPage"
              :page-size="historyPageSize"
              layout="prev, pager, next, jumper"
              :total="historyTotal"
              style="margin: 10px auto; text-align: center"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer" v-if="activeTab === 'return'">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSubmit">立即生效</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from 'api/freight'
import Util from 'utils/util'

export default {
  props: {
    selectedRows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: true,
      activeTab: 'return',
      returnForm: {
        remark: ''
      },
      returnRules: {
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ]
      },
      impactData: [
        {
          returnCustomer: 0,
          coverProvince: '0个'
        }
      ],
      historyData: [],
      historyCurrentPage: 1,
      historyPageSize: 10,
      historyTotal: 0
    }
  },
  mounted() {
    this.calculateImpact()
    this.loadHistory()
  },
  methods: {
    calculateImpact() {
      // 获取选中行的id数组
      const ids = this.selectedRows.map(row => row.id)
      
      if (ids.length === 0) {
        this.impactData = [
          {
            returnCustomer: 0,
            coverProvince: '0个'
          }
        ]
        return
      }
      
      // 调用接口获取影响数据
      http.batchCancelReceiveImpact({ ids }).then(e => {
        if (e.code == 200 && e.data) {
          const customerCount = e.data.customerCount || 0
          const provinceCount = e.data.provinceCount || 0
          
          this.impactData = [
            {
              returnCustomer: customerCount,
              coverProvince: provinceCount + '个'
            }
          ]
        } else {
          // 接口调用失败时使用默认值
          this.impactData = [
            {
              returnCustomer: 0,
              coverProvince: '0个'
            }
          ]
        }
      }).catch(() => {
        // 接口调用异常时使用默认值
        this.impactData = [
          {
            returnCustomer: 0,
            coverProvince: '0个'
          }
        ]
      })
    },
    handleTabClick(tab) {
      if (tab.name === 'history') {
        this.loadHistory()
      }
    },
    loadHistory() {
      const params = {
        pageNum: this.historyCurrentPage,
        pageSize: this.historyPageSize
      }
      
      // 调用历史记录接口
      http.cancelReceiveLogFindPage(params).then(e => {
        if (e.code == 200 && e.data) {
          // 处理返回的数据，确保字段映射正确
          const dataList = e.data.dataList || []
          this.historyData = dataList.map(item => {
            // 格式化操作时间
            let operationTime = ''
            if (item.processTime) {
              operationTime = Util.format(new Date(item.processTime * 1).getTime(), 'yyyy-MM-dd hh:mm:ss')
            }
            
            // 格式化调整影响：impact格式为"2,2"，转换为"退回客户: 2, 覆盖省份: 2个"
            let adjustImpact = ''
            if (item.impact) {
              const impactArr = item.impact.split(',')
              if (impactArr.length >= 2) {
                adjustImpact = `退回客户: ${impactArr[0]}, 覆盖省份: ${impactArr[1]}个`
              } else {
                adjustImpact = item.impact
              }
            }
            
            // 格式化执行状态：1-已执行，0-未执行
            let executionStatusText = ''
            if (item.executionStatus !== undefined && item.executionStatus !== null) {
              executionStatusText = item.executionStatus == 1 ? '已执行' : '未执行'
            }
            
            return {
              operationTime: operationTime,
              operator: item.userName || '',
              adjustImpact: adjustImpact,
              effectiveTime: operationTime, // 生效时间使用操作时间
              executionStatus: executionStatusText,
              remark: item.remark || ''
            }
          })
          this.historyTotal = e.data.total || 0
        } else {
          this.historyData = []
          this.historyTotal = 0
        }
      }).catch(() => {
        this.historyData = []
        this.historyTotal = 0
      })
    },
    handleHistoryPageChange(index) {
      this.historyCurrentPage = index
      this.loadHistory()
    },
    handleSubmit() {
      this.$refs.returnForm.validate(valid => {
        if (valid) {
          const ids = this.selectedRows.map(row => row.id)
          const params = {
            ids: ids,
            remark: this.returnForm.remark
          }
          
          // 调用批量退回接口
          http.batchCancelReceive(params).then(e => {
            if (e.code == 200) {
              this.$message({
                message: '批量退回成功',
                type: 'success'
              })
              this.$emit('closeTask', true)
            } else {
              this.$message({
                message: e.message || '批量退回失败',
                type: 'error'
              })
            }
          }).catch(err => {
            this.$message({
              message: '批量退回失败，请稍后重试',
              type: 'error'
            })
          })
        }
      })
    },
    close() {
      this.$emit('closeTask', false)
    }
  }
}
</script>

<style lang="stylus" scoped>
.block {
  display: flex;
  padding: 5px 0;
  .center {
    margin: 10px auto;
  }
}

/deep/ .el-dialog__body {
  padding: 10px 20px 0px 20px !important;
}

/deep/ .el-form-item {
  margin-bottom: 20px;
}

/deep/ .el-form-item__content {
  width: 100%;
  box-sizing: border-box;
}

.form-label {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;
  margin-bottom: 15px;
  font-weight: normal;
  padding: 0;
}

.required-asterisk {
  color: #F56C6C;
  margin-right: 4px;
}

.impact-table {
  margin-bottom: 20px;
}

/deep/ .el-table {
  width: 100% !important;
  box-sizing: border-box;
}

/deep/ .el-textarea {
  width: 100%;
}

/deep/ .el-textarea__inner {
  width: 100%;
  box-sizing: border-box;
}

/deep/ .el-dialog__header {
  padding: 0;
  background: rgba(52, 109, 176, 0.06);
  border-radius: 2px 2px 0px 0px;

  .el-dialog__title {
    display: block;
    line-height: 56px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    text-align: left;
    font-style: normal;
    padding-left: 30px;
  }
}

/deep/ .el-tabs__header {
  margin: 0 0 20px 0 !important;
  padding: 0 !important;
}

/deep/ .el-tabs__item {
  padding: 0 20px;
  height: 40px;
  line-height: 40px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

.dialog-footer .el-button {
  margin-left: 8px;
}

.dialog-footer .el-button:first-child {
  margin-left: 0;
}
</style>

